/* Jhilke motion v2 fallback runtime (D5 rebuild, 2026-10-01). See jhilke-motion.css for authoring.
   Browsers with CSS scroll-driven animations need none of this beyond the boot flag. Elsewhere it adds
   .is-in once per [data-reveal] or [data-seq] element and feeds --jh-p (0 to 1) to [data-draw] paths. One observer,
   one passive scroll listener writing at most once per frame. Fail-open: any error removes .jh-m.

   Timed settle (R12 motion pass, 2026-10-09): 1.5 s after load, and again when the viewport is resized, anything that
   is animated on scroll and is inside the viewport gets .jh-settled, which forces its final state. Capture tools,
   print and crawlers then see the whole page; an element still below the fold keeps its motion for a real reader.

   One-shot reveal (R13 taste pass, 2026-10-09): [data-rv] is the one reveal for tiles, rows, FAQ items, founder, gallery
   and newsletter: 12 px up and in over 350 ms, once, when the element's top passes 90 percent of the viewport. No
   stagger. The class jh-rv on <html> (which hides anything) is added only after the elements in view have been marked,
   only when motion is allowed (.jh-m), and a scroll sweep reveals everything at or above that line, so a fast scroll
   or a jump to an anchor cannot leave an element hidden. Reduced motion, print and no JS show the final state. */
(function () {
  'use strict';
  var root = document.documentElement;

  // The animated elements: the theme's hooks ([data-reveal], [data-rv], [data-draw]). PIECE is for any extra selectors
  // a section needs; it is empty today, because the piece section marks its elements with those same hooks.
  var PIECE = [];
  var SEL = ['[data-reveal]', '[data-rv]', '[data-draw]'].concat(PIECE).join(',');
  var FORCE = 'animation:none!important;transition:none!important;opacity:1!important;transform:none!important;' +
    'clip-path:none!important;stroke-dashoffset:0!important;';

  try {
    // Force rules, for the settled class and for print
    var settled = SEL.split(',').map(function (s) { return 'html ' + s + '.jh-settled'; }).join(',');
    var printSel = SEL.split(',').map(function (s) { return 'html ' + s; }).join(',');
    var css = settled + '{' + FORCE + '}' +
      '@media print{' + printSel + '{' + FORCE + '}}';
    var st = document.createElement('style');
    st.setAttribute('data-jh-settle', '');
    st.textContent = css;
    document.head.appendChild(st);

    var settle = function () {
      var vh = window.innerHeight, vw = window.innerWidth;
      // Read every rect first, then write the classes, so layout is computed once
      var hit = [];
      Array.prototype.forEach.call(document.querySelectorAll(SEL), function (el) {
        // A reveal that has started (is-in) is left to finish; settle only completes one that never began.
        if (el.classList.contains('jh-settled') || el.classList.contains('is-in')) return;
        var r = el.getBoundingClientRect();
        // data-rv-late waits for its own observer; only one already scrolled past (bottom above the screen) is settled here
        if (el.hasAttribute('data-rv-late') && r.bottom > 0) return;
        if (r.bottom > 0 && r.top < vh && r.right > 0 && r.left < vw) hit.push(el);
      });
      hit.forEach(function (el) { el.classList.add('jh-settled'); });
    };
    var lastW = window.innerWidth, lastH = window.innerHeight, rt = 0;
    var afterLoad = function () { setTimeout(settle, 1500); };
    if (document.readyState === 'complete') afterLoad(); else window.addEventListener('load', afterLoad);
    // A resize that changes the width or the height by 150 px or more (a capture tool growing the viewport to the
    // page height, a rotation). A phone's address bar sliding in and out moves the height by less and is ignored.
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () {
        var dw = Math.abs(window.innerWidth - lastW), dh = Math.abs(window.innerHeight - lastH);
        lastW = window.innerWidth; lastH = window.innerHeight;
        if (dw > 0 || dh >= 150) settle();
      }, 60);
    });
  } catch (e) { /* the settle is a safety net only */ }

  try {
    // One-shot reveal for [data-rv], in every browser (see the header comment)
    if (root.classList.contains('jh-m')) {
      var pend = Array.prototype.slice.call(document.querySelectorAll('[data-rv]:not([data-rv-late])'));
      var late = Array.prototype.slice.call(document.querySelectorAll('[data-rv][data-rv-late]'));
      if (pend.length || late.length) {
        var st2 = document.createElement('style');
        st2.setAttribute('data-jh-rv', '');
        st2.textContent = 'html.jh-rv [data-rv]:not(.is-in){opacity:0;transform:translate3d(0,12px,0);}' +
          'html.jh-rv [data-rv]{transition:opacity 350ms cubic-bezier(.22,1,.36,1),transform 350ms cubic-bezier(.22,1,.36,1);}' +
          'html.jh-rv [data-rv].is-instant{transition:none;}' +
          '@media print{html [data-rv]{opacity:1!important;transform:none!important;transition:none!important;}}';
        document.head.appendChild(st2);
        var rvQueued = false;
        var sweepRv = function () {
          rvQueued = false;
          var line = window.innerHeight * 0.9, hit = [];
          pend.forEach(function (el) { if (el.getBoundingClientRect().top < line) hit.push(el); });
          if (!hit.length) return;
          hit.forEach(function (el) { el.classList.add('is-in'); });
          pend = pend.filter(function (el) { return hit.indexOf(el) < 0; });
          if (!pend.length) { window.removeEventListener('scroll', onRv); window.removeEventListener('resize', onRv); }
        };
        var onRv = function () { if (!rvQueued) { rvQueued = true; requestAnimationFrame(sweepRv); } };
        // Already in view at boot: final state at once, no transition
        var vh0 = window.innerHeight * 0.9;
        pend.forEach(function (el) { if (el.getBoundingClientRect().top < vh0) el.classList.add('is-instant', 'is-in'); });
        pend = pend.filter(function (el) { return !el.classList.contains('is-in'); });
        // data-rv-late: the reveal starts later than the shared line, when about half the element is in view and it sits
        // above the bottom quarter of the screen (a second observer: rootMargin -25 percent, threshold 0.5).
        if (late.length) {
          var vhL = window.innerHeight;
          late = late.filter(function (el) {
            var r = el.getBoundingClientRect();
            var seen = Math.min(r.bottom, vhL * 0.75) - Math.max(r.top, 0);
            if (r.height > 0 && seen >= r.height * 0.5) { el.classList.add('is-instant', 'is-in'); return false; }
            return true;
          });
          if ('IntersectionObserver' in window) {
            var ioLate = new IntersectionObserver(function (entries) {
              entries.forEach(function (en) {
                if (en.isIntersecting) { en.target.classList.add('is-in'); ioLate.unobserve(en.target); }
              });
            }, { rootMargin: '0px 0px -25% 0px', threshold: 0.5 });
            late.forEach(function (el) { ioLate.observe(el); });
            // Scrolled past before it reached half in view: show the final state at once (the settle path), never a reveal
            // nobody sees.
            var passLate = function () {
              late = late.filter(function (el) {
                if (el.classList.contains('is-in')) return false;
                if (el.getBoundingClientRect().bottom < 0) { ioLate.unobserve(el); el.classList.add('jh-settled'); return false; }
                return true;
              });
              if (!late.length) window.removeEventListener('scroll', passLate);
            };
            window.addEventListener('scroll', passLate, { passive: true });
          } else {
            // No observer: the shared sweep takes over
            pend = pend.concat(late);
          }
        }
        root.classList.add('jh-rv');
        window.addEventListener('scroll', onRv, { passive: true });
        window.addEventListener('resize', onRv);
        window.addEventListener('hashchange', onRv);
        setTimeout(onRv, 1500);
      }
    }
  } catch (e) { root.classList.remove('jh-rv'); }

  try {
    window.__jhMotion = true;
    if (!root.classList.contains('jh-m')) return;
    if (window.CSS && CSS.supports && CSS.supports('animation-timeline: view()')) return;

    var reveal = document.querySelectorAll('[data-reveal],[data-seq]');
    if ('IntersectionObserver' in window && reveal.length) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.01 });
      Array.prototype.forEach.call(reveal, function (el) {
        // Already on screen at boot: show at once, no transition, so nothing flickers above the fold
        if (el.getBoundingClientRect().top < window.innerHeight) { el.classList.add('is-instant', 'is-in'); return; }
        io.observe(el);
      });
    }

    var draws = Array.prototype.slice.call(document.querySelectorAll('[data-draw]'));
    if (draws.length) {
      draws.forEach(function (p) { if (!p.getAttribute('pathLength')) p.setAttribute('pathLength', '1'); });
      var queued = false;
      var update = function () {
        queued = false;
        var vh = window.innerHeight;
        draws.forEach(function (p) {
          var r = p.getBoundingClientRect();
          var t = Math.min(1, Math.max(0, (vh * 0.9 - r.top) / (r.height + vh * 0.5)));
          p.style.setProperty('--jh-p', t.toFixed(3));
        });
      };
      window.addEventListener('scroll', function () { if (!queued) { queued = true; requestAnimationFrame(update); } }, { passive: true });
      update();
    }
  } catch (e) {
    root.classList.remove('jh-m');
  }
})();
